import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { projectSettingsSpacePoliciesEntryPoint } from '@jira/spa-apps__project-settings-space-policies/src/projectSettingsSpacePoliciesEntryPoint.entrypoint.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { polarisProjectLayout } from '@jira/platform__layouts-polaris-project-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { polarisProjectSettingsPoliciesRoute } from '@jira/router-routes__polaris-routes/src/polarisProjectSettingsPoliciesRoute.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { fg } from '@atlassian/jira-feature-gating';

const projectSettingsSpacePoliciesPageEntryPoint = createPageEntryPoint({
	main: projectSettingsSpacePoliciesEntryPoint,
});

export const polarisProjectSettingsPoliciesRouteEntry: Route = createEntry(
	polarisProjectSettingsPoliciesRoute,
	() => ({
		isStrictModeEnabled: false,
		group: 'polaris',
		ufoName: 'project-settings.space-policies.jpd',
		layout: polarisProjectLayout,
		canTransitionIn: () => true,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [
			...getNavigationResources(),
			incidentExperimentTraitResource,
			// eslint-disable-next-line jira/router/no-project-context-resource
			projectContextResource,
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
		],

		entryPoint: () =>
			fg('frontier-guided-autonomy-space-settings')
				? projectSettingsSpacePoliciesPageEntryPoint
				: notFoundPageEntrypoint,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
